import React, { useState } from 'react'

import { Button, Icon, Modal } from 'antd'
import 'primeflex/primeflex.css'
import 'primeicons/primeicons.css'
import 'primereact/resources/primereact.css'
import 'primereact/resources/themes/lara-light-indigo/theme.css'
import { Toolbar } from 'primereact/toolbar'

import { getMessage } from '../../../util/IntlMessages'
import CreateGroup from './CreateGroup'

const Header = ({ customerId, updateGroupsList, customerLocations, districts, onGroupCreated }) => {
  const [modalGroupVisible, setModalGroupVisible] = useState(false)
  return (
    <Toolbar
      left={<h3 style={{ fontWeight: 'bold' }}>Grupos</h3>}
      style={{ background: 'white', border: 'none', padding: '10px', fontSize: '14px' }}
      right={
        <React.Fragment>
          <Button
            type="dashed"
            style={{ gap: '5px', color: 'white', fontWeight: '500' }}
            onClick={() => setModalGroupVisible(true)}
          >
            <Icon type="plus" size="small" style={{ color: '#fff', fontSize: 12, fontWeight: '500' }} />
            <span style={{ fontWeight: '500' }}>{getMessage('createGroup')}</span>
          </Button>
          <Modal
            title={<h3 style={{ fontWeight: 'bold' }}>{getMessage('createGroup')}</h3>}
            footer={null}
            onCancel={() => setModalGroupVisible(!modalGroupVisible)}
            visible={modalGroupVisible}
          >
            <CreateGroup
              setModalGroupVisible={setModalGroupVisible}
              customerId={customerId}
              updateGroupsList={updateGroupsList}
              customerLocations={customerLocations}
              districts={districts}
              onGroupCreated={onGroupCreated}
            />
          </Modal>
        </React.Fragment>
      }
    />
  )
}

export default Header
